export const downloadBlob = (blobData: BlobPart, name: string = 'data') => {
    const blob = new Blob([blobData], { type: 'text/csv' })

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, `${name}.csv`)
    } else {
        const elem = window.document.createElement('a')
        elem.href = window.URL.createObjectURL(blob)
        elem.download = `${name}.csv`
        document.body.appendChild(elem)
        elem.click()
        document.body.removeChild(elem)
    }
}
